import { CONSTANTS_STRINGS } from "../../Utils/Constant";

function SuccessStories() {
  const successData = CONSTANTS_STRINGS?.SuccssesStorie;
  const successStories = successData?.SuccssesStories || [];

  if (!successStories || successStories.length === 0) {
    return (
      <p className="text-center text-xl text-white">
        No success stories available at the moment.
      </p>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center w-full h-auto mx-auto bg-[#24283e] text-white pt-15">
      {/* Header Section */}
      <div className="flex flex-col justify-between items-center p-10 text-center">
        <p className="bg-gray-600 px-4 py-2 text-xs font-semibold mb-8">
          {successData.t1}
        </p>
        <p className="text-4xl font-semibold">{successData.t2}</p>
        <p className="text-xl mt-6">{successData.t3}</p>
      </div>

      {/* Success Stories Scrollable Grid */}
      <div className="w-full overflow-x-auto no-scrollbar ">
        <div className="flex w-max ">
          {successStories.map((item, index) => (
            <div
              key={index}
              className="md:w-[381px] md:h-[620px] w-[300px] h-[500px] rounded-t-2xl mb-2 flex-shrink-0 relative group overflow-hidden cursor-pointer"
            >
              {/* Image */}
              <img
                src={item.src}
                alt="Success story"
                className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#24283e]/60 group-hover:from-[#24283e]/100 to-transparent transition-all duration-500"></div>

              {/* Text Content */}
              <div className="absolute inset-0 flex flex-col justify-end w-full px-6 z-20">
                <h1 className="text-white text-3xl font-semibold mb-2 transition-all duration-500 group-hover:-translate-y-10">
                  {item.text}
                </h1>
                <h2 className="text-white text-xs transition-all mb-0 duration-500 group-hover:-translate-y-10">
                  {item.text1}
                </h2>
                <h2 className="text-white text-[16px] mb-10 transition-all duration-500 transform group-hover:translate-y-0 translate-y-28">
                  {item.text3}
                </h2>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SuccessStories;
